import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import * as moment from 'moment'
// import * as actions from './actions'
// import * as getters from './getters'
// import cart from './modules/cart'
// import products from './modules/products'
// import createLogger from '../../../src/plugins/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
const API_URL = 'https://www.artkina.cz/api/1.4'

export default new Vuex.Store({
	state: {
		// Search query state
		search: {
			until: null,
			since: null,
			cinemas: null
		},

		// List of cinemas
		cinemas: [],

		// List of all projections
		projections: [],

		statuses: {
			cinemas: true,
			projections: true,
			detail: true
		},

		// Projection detail
		projection: {
			'fake': true,
			'date': {
				'date': '2017-09-15 23:00:00'
			},
			'price': 0,
			'language': 'vestibulum eu, molestie',
			'enabled': true,
			'id': 59550,
			'movie_id': 7069,
			'cinema_id': 1,
			'csfd_link': null,
			'csfd_rating': null,
			'imdb_rating': null,
			'movie': {
				'title': 'Nam ipsum risus',
				'title_orig': 'Nam ipsum risus',
				'year': 2017,
				'description': 'Nam ipsum risus, rutrum vitae, vestibulum eu, molestie vel, lacus. Duis arcu tortor, suscipit eget, imperdiet nec, imperdiet iaculis, ipsum. Aliquam eu nunc. Curabitur a felis in nunc fringilla tristique. Sed fringilla mauris sit amet nibh. Praesent nec nisl a purus blandit viverra. Phasellus accumsan cursus velit. Ut id nisl quis enim dignissim sagittis. Sed augue ipsum, egestas nec, vestibulum et, malesuada adipiscing, dui. Suspendisse non nisl sit amet velit hendrerit rutrum. Sed cursus turpis vitae tortor. Etiam sit amet orci eget eros faucibus tincidunt. Morbi mattis ullamcorper velit. Fusce commodo aliquam arcu. Praesent nonummy mi in odio.',
				'length': 120,
				'country': 'Czech Republic',
				'id': 123,
				'youtube': null
			}
		},

		// Displayed trailer
		trailer: null,

		// Very first  date header in the program list
		programDateHeaderFirst: null,

		// What's the last displayed date header in the program list
		programDateHeader: null,

		// Index of currently active section on mobile (or tablet)
		activeSectionIndex: 1,

		sections: [
			{title: 'Kina', slug: 'cinemas'},
			{title: 'Program', slug: 'program'},
			{title: 'Projekce', slug: 'detail'}
		]
	},
	mutations: {
		search (state, search) {
			state.search = search
		},
		cinemas (state, cinemas) {
			state.cinemas = cinemas
		},
		toggleCinema (state, {city, index, status = null}) {
			state.cinemas[city][index].active = status === null ? !state.cinemas[city][index].active : status
		},
		projections (state, {projections, append = false}) {
			if (append === false) {
				state.projections = projections
			} else {
				state.projections = [...state.projections, ...projections]
			}
		},
		projection (state, payload) {
			state.projection = payload
		},
		trailer: function (state, payload) {
			if (payload) {
				document.querySelector('html').classList.add('lightbox--active', 'lightbox--active-trailer')
			} else {
				document.querySelector('html').classList.remove('lightbox--active', 'lightbox--active-trailer')
			}
			state.trailer = payload
		},
		statuses (state, payload) {
			state.statuses = {...state.statuses, ...payload}
		},
		programDateHeader (state, date) {
			state.programDateHeader = date
		},
		programDateHeaderFirst (state, date) {
			state.programDateHeaderFirst = date
		},
		activeSectionIndex (state, index) {
			state.activeSectionIndex = index
		}
	},
	getters: {
		apiUrl: () => API_URL,

		debug: () => debug,

		/**
		 * Get selected cinemas - all, by slug or by id
		 * @param slug|id
		 * @return array
		 */
		selectedCinemas: (state) => (slug = null) => {
			const cinemas = state.cinemas
			const selectedCinemas = []
			let selectedCinema = null

			for (let city in cinemas) {
				cinemas[city].forEach((cinema, index) => {
					if (cinemas[city][index].active) {
						if (parseInt(slug) === cinemas[city][index].id) {
							selectedCinema = cinemas[city][index]
						}
						if (slug === city || slug === null) {
							selectedCinemas.push(cinemas[city][index])
						}
					}
				})
			}
			return selectedCinema !== null ? selectedCinema : selectedCinemas
		},

		activeSection: (state) => {
			return state.sections[state.activeSectionIndex]
		},

		getCinemas: (state) => {
			let cinemas = state.cinemas
			for (const slug in cinemas) {
				cinemas[slug].sort((a, b) => a.name > b.name ? 1 : (a.name === b.name ? 0 : -1))
			}
			return cinemas
		}
	},

	actions: {
		/**
		 * Initial load of the cinemas
		 * @param {*} state
		 * @param {*} cities
		 */
		cinemas ({commit, state, dispatch}, cities) {
			const askForPosition = (options = {}) => {
				return new Promise(function (resolve, reject) {
					navigator.geolocation.getCurrentPosition(resolve, reject, options)
				})
			}

			const loadCinemas = (cities, active) => {
				for (let city in cities) {
					cities[city].forEach((cinema, index) => {
						cities[city][index].active = (city === active)
					})
				}
				commit('cinemas', cities)
			}

			const toggleClosestCinema = (cities, closest = null) => {
				for (let city in cities) {
					cities[city].forEach((cinema, index) => {
						if (city === closest.city) {
							commit('toggleCinema', {city: city, index: index, status: true})
						} else {
							commit('toggleCinema', {city: city, index: index, status: false})
						}
					})
				}
				dispatch('loadProjections')
			}

			const deg2rad = (deg) => deg * (Math.PI / 180)

			const getDistance = (lat1, lon1, lat2, lon2) => {
				const R = 6371 // Radius of the earth in km
				const dLat = deg2rad(lat2 - lat1) // deg2rad below
				const dLon = deg2rad(lon2 - lon1)
				const a =
					Math.sin(dLat / 2) * Math.sin(dLat / 2) +
					Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
					Math.sin(dLon / 2) * Math.sin(dLon / 2)

				const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
				const d = R * c // Distance in km
				return d
			}

			loadCinemas(cities, 'Praha')
			dispatch('loadProjections')

			let closest = {city: 'Praha', distance: 0}
			askForPosition()
				.then((position) => {
					const {latitude: lat, longitude: lng} = position.coords
					for (let city in cities) {
						const cinema = cities[city][0] // all we care about is one cinema from each city
						const distance = getDistance(...cinema.gps.split(','), lat, lng)
						if (closest.distance === 0 || closest.distance > distance) {
							closest.city = city
							closest.distance = distance
						}
					}
					toggleClosestCinema(cities, closest)
				})
				.catch((err) => {
					console.warn(`ERROR(${err.code}): ${err.message}`)
				})
		},

		/**
		 * Load projections based on selected cinemas.
		 */
		loadProjections ({commit, state, getters}) {
			const cinemas = `${getters.selectedCinemas().map(cinema => cinema.slug)}`

			// TODO: Refactor with moment
			const days = 2
			let until = new Date(((new Date().getTime() / 1000) + 24 * days * 3600) * 1000)
			let [year, month, day] = [until.getFullYear(), until.getMonth() + 1, until.getDate()]
			month = month < 10 ? `0${month}` : month
			day = day < 10 ? `0${day}` : day
			until = `${year}-${month}-${day}`

			commit('statuses', {projections: false})
			axios.get(`${API_URL}/projection/list/${cinemas}/${until}`)
				.then(function (response) {
					// Sort by date
					response.data.data.sort((a, b) => moment(a.date.date).format('X') - moment(b.date.date).format('X'))

					// Commit mutations
					commit('projections', {projections: response.data.data})
					commit('statuses', {projections: true})

					// Set the first date header in program
					const formatedDate = moment(response.data.data[0].date.date).format('DD.MM.YYYY')
					commit('programDateHeaderFirst', formatedDate)
					commit('programDateHeader', formatedDate)

					// Update the search query
					commit('search', {until: until, cinemas: cinemas})
				})
				.catch(function (error) {
					console.warn(error)
					commit('statuses', {projections: true})
				})
		},

		toggleCity ({commit, state, dispatch}, city) {
			state.cinemas[city].forEach((cinema, index) => {
				commit('toggleCinema', {city: city, index: index})
			})
			dispatch('loadProjections')
		},

		/**
		 * Toggling cinemas. Once done, dispatch async action loadProjections.
		 */
		toggleCinema ({commit, state, dispatch}, toggledCinema) {
			const cinemas = state.cinemas
			for (let city in cinemas) {
				cinemas[city].forEach((cinema, index) => {
					if (cinema === toggledCinema) {
						commit('toggleCinema', {city: city, index: index})
					}
				})
			}
			dispatch('loadProjections')
		},

		/**
		 * Load more projections
		 */
		loadMore ({commit, state, dispatch}) {
			let {cinemas, until, since} = state.search
			since = until
			until = moment(until).add(1, 'days').format('YYYY-MM-DD')

			commit('statuses', { projections: false })
			axios.get(`${API_URL}/projection/list/${cinemas}/${until}/${since}`)
			.then(function (response) {
				// Sort by date
				response.data.data.sort((a, b) => moment(a.date.date).format('X') - moment(b.date.date).format('X'))

				// Commit mutations
				commit('projections', {projections: response.data.data, append: true})

				// Update the search query
				commit('search', {until: until, since: since, cinemas: cinemas})

				commit('statuses', { projections: true })
			})
			.catch(function (error) {
				console.warn(error)
				commit('statuses', {projections: true})
			})
		}
	},
	strict: debug
	// plugins: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./src/store/index.js